import React, { useEffect } from "react";
import { Icon, Popover, Button } from "antd";
import { withMsal, useMsal } from "@azure/msal-react";
// import { logOutUrl } from "../../../config/adal";
import { msalConfig } from "../../../config/msal/authConfig";
import { store } from "../../../index";

const UserInfo = ({ userInfo, msalContext }) => {
  const { accounts } = useMsal();
  const isAuthenticated = msalContext.accounts.length > 0;
  let name = '';
  let username = '';
  let roles = [];
  if (isAuthenticated) {
    name = msalContext.accounts[0].name;
    username = msalContext.accounts[0].username;
    roles = msalContext.accounts[0].idTokenClaims.roles || [];
  }
  const logout = () => {
    const { instance } = msalContext;
    const homeAccountId = accounts[0].homeAccountId;

    const logoutRequest = {
      account: instance.getAccountByHomeId(homeAccountId),
      postLogoutRedirectUri: msalConfig.auth.redirectUri,
    };
    instance.logoutRedirect(logoutRequest);
    store.dispatch({ type: "REMOVE_TOKEN" })
  };
  return (
    <Popover
      trigger="click"
      title={roles.indexOf("DataSteward") > -1 ? (
        <strong className="user-name">
          {roles.indexOf("DataSteward") > -1 && (
            <div className="user-role">DataSteward</div>
          )}
        </strong>
      ) : null}
      placement="bottomRight"
      overlayClassName="user-info-popover"
      className="user-info"
      content={
        <div className="user-info-actions">
          <ul>
            <li>
              <Icon type="idcard" />
              {username}
            </li>
            <li>
              <span className="logout-button" onClick={logout}>
                <Icon type="logout" />
                Logout
              </span>
            </li>
          </ul>
        </div>
      }
    >
      <Button icon="user" size="small" style={{ fontSize: 18 }} shape="circle" />
      <span>{name}</span>
    </Popover>
  );
}

export default withMsal<any>(UserInfo);
